import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { ProveedoresService } from "src/app/views/catalogs/proveedores/proveedores.service";
import { TipoMaterialesService } from "../../../catalogs/tipos-materiales/tipos-materiales.service";
import { MatChipInputEvent } from "@angular/material/chips";
import { MaterialsService } from "../materials.service";
import { NgxImageCompressService } from "ngx-image-compress";
import dataURItoBlob from "src/app/utils/dataURItoBlob";

@Component({
  selector: "app-form-material",
  templateUrl: "./form.component.html",
})
export class MaterialForm implements OnInit {
  public imgDef =
    "https://us.123rf.com/450wm/tvectoricons/tvectoricons1811/tvectoricons181105271/112229760-add-photos-icon-trendy-flat-vector-add-photos-icon-on-white-background-from-general-collection.jpg?ver=6";

  public form: FormGroup;
  public mode: "stanby" | "create" | "update" = "stanby";
  public defaults?: any = undefined;

  public proveedores: any[] = [];
  public tiposmateroal: any[] = [];
  public tags: string[] = [];
  @ViewChild("imageInput", { static: false }) public imageInput: ElementRef;
  public valueImg = "";
  public imgFile: File = undefined;

  @Output() onsave = new EventEmitter<{
    mode: string;
    value: any;
    file: File;
  }>();
  constructor(
    private fb: FormBuilder,
    private service: MaterialsService,
    private proServ: ProveedoresService,
    private tiposMatServ: TipoMaterialesService,
    private imageCompress: NgxImageCompressService
  ) {}

  public ngOnInit() {
    this.buildForm();
    this.proServ.get().subscribe((s) => {
      this.proveedores = s;
    });
    this.tiposMatServ.get().subscribe((s) => {
      this.tiposmateroal = s;
    });
  }
  public setStanby() {
    this.mode = "stanby";
    this.defaults = undefined;
    this.form.reset();
  }
  public setCreate() {
    this.mode = "create";
    this.defaults = undefined;
    this.tags = [];
    this.form.reset();
  }

  public setUpdate(row: any) {
    this.mode = "update";
    this.defaults = row;

    this.form.controls["IdMaterial"].setValue(this.defaults?.IdMaterial);
    this.form.controls["IdTipoMaterial"].setValue(
      this.defaults?.IdTipoMaterial
    );
    this.form.controls["IdProveedor"].setValue(this.defaults?.IdProveedor);
    this.form.controls["Descripcion"].patchValue(this.defaults?.Descripcion);
    this.form.controls["NoParteInterno"].patchValue(
      this.defaults?.NoParteInterno
    );
    this.form.controls["NoParteExterno"].patchValue(
      this.defaults?.NoParteExterno
    );
    this.form.controls["Tags"].patchValue(this.defaults?.Tags);
    this.form.controls["Minimo"].patchValue(this.defaults?.Minimo);
    this.form.controls["Ubicacion"].patchValue(this.defaults?.Ubicacion);

    this.tags = this.defaults!.Tags.split(",");
    this.loadImage();
  }

  public save() {
    if (this.mode === "create") this.create();
    else if (this.mode === "update") this.update();
  }

  public create() {
    const data = this.form.value;
    const tagsStr = this.tags.join(",");

    this.onsave.emit({
      mode: this.mode,
      value: { ...data, tags: tagsStr },
      file: this.imgFile,
    });
  }

  public update() {
    const data = this.form.value;
    const tagsStr = this.tags.join(",");
    this.onsave.emit({
      mode: this.mode,
      value: { ...data, tags: tagsStr },
      file: this.imgFile,
    });
  }

  public isCreateMode() {
    return this.mode === "create";
  }

  public isUpdateMode() {
    return this.mode === "update";
  }

  addKeywordFromInput(event: MatChipInputEvent) {
    if (event.value) {
      this.tags.push(event.value);
      event.chipInput!.clear();
    }
  }

  removeKeyword(keyword: string) {
    this.tags = [...this.tags.filter((f) => f !== keyword)];
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      IdMaterial: [""],
      IdTipoMaterial: [""],
      IdProveedor: [""],
      Descripcion: [""],
      NoParteInterno: [""],
      NoParteExterno: [""],
      Tags: [""],
      Minimo: [""],
      Ubicacion: [""],
    });
  }
  public loadImage() {
      this.valueImg = this.defaults?.Foto ?? this.imgDef;
    // this.service.image(this.defaults.Foto).subscribe(
    //   (str) => (this.valueImg = str),
    //   (err) => (this.valueImg = this.imgDef)
    // );
  }
  public getImgFile() {
    this.imageCompress.uploadFile().then(({ image, orientation }) => {
      this.imageCompress
        .compressFile(image, orientation, 50, 50) // 50% ratio, 50% quality
        .then((compressedImage) => {
          const blob = dataURItoBlob(compressedImage);
          this.valueImg = compressedImage;
          this.imgFile = new File(
            [blob],
            "Imagen" + new Date().getTime().toString(16)
          );
        });
    });
  }
  errorHandler(event) {
    event.target.src = this.imgDef;
  }
}
